import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { CaptchaService } from '../captcha/captcha.service';
import { IMyDpOptions } from 'mydatepicker';
import { AmazingTimePickerService } from 'amazing-time-picker';
import { ViewChild } from '@angular/core';
import { ReCaptchaComponent } from 'angular2-recaptcha';

import { Perfil } from '../perfil/perfil';
import { PerfilService } from '../perfil/perfil.service';

import { Vinculo } from '../vinculo/vinculo';
import { VinculoService } from '../vinculo/vinculo.service';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';

import { Comunicado } from '../comunicado/comunicado';
import { ComunicadoService } from '../comunicado/comunicado.service';

import { RelacaoIncidente } from '../relacao-incidente/relacao-incidente';
import { RelacaoIncidenteService } from '../relacao-incidente/relacao-incidente.service';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciaService } from '../denuncia/denuncia.service';

import { RequestOptions, Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';

import { URL_API } from './../constante';

const URL = URL_API + '/upload';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'],
  providers: [
    PerfilService,
    VinculoService,
    IncidenteService,
    ComunicadoService,
    RelacaoIncidenteService,
    DenunciaService,
	CaptchaService
  ]
})
export class InicioComponent implements OnInit {
	@ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;

  // variaveis para componente do calendario
  public hoje = new Date();
  public amanha = new Date();

	public myDatePickerOptions: IMyDpOptions = {
        dayLabels: {su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab"},
		    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
		    dateFormat: "dd/mm/yyyy",
		    todayBtnTxt: "Hoje",
		    firstDayOfWeek: "su",
		    sunHighlight: true,
        markCurrentDay: true,
        disableSince: {year: this.hoje.getFullYear(), month: this.hoje.getMonth()+1, day: this.hoje.getDate()},
        enableDays: [{year: this.hoje.getFullYear(), month: this.hoje.getMonth()+1, day: this.hoje.getDate()}]
    };

	public maskdata: any = ""; //{ date: { year: 2018, month: 10, day: 9 } };

	public maskhora = ""; //'18:33';
          open() {
            const amazingTimePicker = this.atp.open({
                locale: 'pt-br',
            });
            amazingTimePicker.afterClose().subscribe(time => {
                this.maskhora = time;
            });
	}

  captchaValido:boolean;
  dadosCaptcha: any;
  outroPerfil: boolean;
  outroVinculo: boolean;
  outroIncidente: boolean;
  outroComunicado: boolean;
  outroRelacao: boolean;
  opcaoComun: boolean;

  anonimoDenunciante: boolean;
  opcaoPerfilDenunciante: number;
  opcaoVinculoDenunciante: number;
  opcaoTipoIncidente: number;
  opcaoCominucacaoOutro: number;

  perfis: Perfil[];
  vinculos: Vinculo[];
  incidentes: Incidente[];
  comunicados: Comunicado[];
  relacoes: RelacaoIncidente[];

  denuncia: Denuncia;

  itensRelIncidente = [];
  itensTipoIncidente = [];
  itensTipoComunicado = [];

  // mascara data e hora do incidente
  public maskDHInc = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/, ' ', /[0-1-2]/, /\d/, ':', /[0-5]/, /\d/, ':', /[0-5]/, /\d/]

  public uploader:FileUploader = new FileUploader({url: URL, itemAlias: 'arquivo', maxFileSize: 10*1024*1024, allowedMimeType: ['application/msword', 'application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'audio/mpeg3', 'video/mp4', 'application/x-troff-msvideo', 'video/x-ms-wmv', 'video/quicktime' ] });

  nomeFakeArquivo: string;

  labelBtnSalvar: string = "Salvar";

  constructor(
    private perfilService: PerfilService,
    private vinculoService: VinculoService,
    private incidenteService: IncidenteService,
    private comunicadoService: ComunicadoService,
    private relacaoService: RelacaoIncidenteService,
    private denunciaService: DenunciaService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private http: Http,
	  private captchaService: CaptchaService,
	  private atp: AmazingTimePickerService
  ) {
    this.denuncia = new Denuncia;
    this.anonimoDenunciante = false;
    this.http = http;

  }

  getPerfis(): void {
    this.perfilService.getPerfis()
    .then(perfil => this.perfis = perfil);
  }
  getVinculos(): void {
    this.vinculoService.getVinculos()
    .then(vinculo => this.vinculos = vinculo);
  }
  getIncidentes(): void {
    this.incidenteService.getIncidentes()
    .then(incidente => this.incidentes = incidente);
  }
  getComunicados(): void {
    this.comunicadoService.getComunicados()
    .then(comunicado => this.comunicados = comunicado);
  }
  getRelacoes(): void {
    this.relacaoService.getRelacoes()
    .then(relacao => this.relacoes = relacao);
  }

  onChangePerfil(item) {
    this.outroPerfil = (item==0?true:false);
  }

  onChangeVinculo(item) {
    this.outroVinculo = (item==0?true:false);
  }
  subOutroVinculo(bool: boolean) {
    this.outroVinculo = bool;
  }

  subOutroIncidente() {
    this.outroIncidente = !this.outroIncidente;
  }

  subOutroComunicado() {
    this.outroComunicado = !this.outroComunicado;
  }
  subOutroRelacao() {
    this.outroRelacao = !this.outroRelacao;
  }
  subOpcaoComun(bool: boolean) {
    this.opcaoComun = bool;
  }

  selRelacaoIncidente(value,event){
    if (event.target.checked) {
      this.itensRelIncidente.push(value);
    }
    else if (!event.target.checked) {
      let indexx = this.itensRelIncidente.indexOf(value);
      this.itensRelIncidente.splice(indexx,1);
    }

  }

  selTipoIncidente(value,event){
    if (event.target.checked) {
      this.itensTipoIncidente.push(value);
    }
    else if (!event.target.checked) {
      let indexx = this.itensTipoIncidente.indexOf(value);
      this.itensTipoIncidente.splice(indexx,1);
    }

  }


  selTipoComunicado(value,event){
      if (event.target.checked) {
        this.itensTipoComunicado.push(value);
      }
      else if (!event.target.checked) {
        let indexx = this.itensTipoComunicado.indexOf(value);
        this.itensTipoComunicado.splice(indexx,1);
      }

  }

  limpaCampos() {
    this.denuncia.nomeDenunciante = "";
    this.denuncia.emailDenunciante = "";
    this.denuncia.telefoneDenunciante = "";
  }

  ngOnInit() {
    // sobrescrevendo o metodo onAfterAddingFile, retirando a parte de verificacao de credenciais no upload
    this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };

    // sobrescrevendo o metodo onCompleteItem para lidar com a resposta do servidor (upload bem sucedido)
    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
            //console.log("ImageUpload:uploaded:", item, status, response);
            alert('Arquivo gravado com sucesso!');
            this.nomeFakeArquivo = response; // nome do arquivo criptografado

    };

	  this.captchaValido = false;
    this.outroPerfil = false;
    this.outroVinculo = false;
    this.outroIncidente = false;
    this.outroComunicado = false;
    this.outroRelacao = false;
    this.opcaoComun = false;

    this.getPerfis();
    this.getVinculos();
    this.getIncidentes();
    this.getComunicados();
    this.getRelacoes();
  }

  salvar(): void {
    this.labelBtnSalvar = "Aguarde";
    if (this.anonimoDenunciante == true){
      this.denuncia.anonimoDenunciante = 1;
    } else if (this.anonimoDenunciante == false){
      this.denuncia.anonimoDenunciante = 0;
    }
    this.denuncia.chaveAcessoDenunciante = 'trueValue';

    // setando os ids dos itens relacao de incidente
    this.denuncia.DitensRelIncidente = this.itensRelIncidente;

    // setando os ids dos itens tipo de incidente
    this.denuncia.itensTipoIncidenteFinal = this.itensTipoIncidente;

    // setando os ids dos itens da comunicacao do incidente
    this.denuncia.itensTipoComunicadoFinal = this.itensTipoComunicado;

    // setando o nome do arquivo criptografado
    this.denuncia.nomeArquivo = this.nomeFakeArquivo;

      if (!this.denuncia.id) {
	       //console.log(this.itensTipoComunicado);
         this.denunciaService.saveDenuncia(this.denuncia)
            .then(() => this.goBack());
      }

  }

  goBack(): void {
	 var inputs = document.getElementsByTagName('input');
    for(var i in inputs) {
        if(inputs[i].type === 'checkbox') {
            inputs[i].checked = false;
        }
    }
	 this.captcha.reset();
	 this.maskhora = "";
	 this.maskdata = "";
	 window.scrollTo(0,0);
   this.labelBtnSalvar = "Salvar";
   this.captchaValido = false;
   this.router.navigate(['inicio']);

  }

	verifyCallback(token){
		this.captchaService.validaCaptcha(token).then((result) => {
			//console.log(result);
			this.dadosCaptcha = result;
			//console.log(this.dadosCaptcha.success);
			if(this.dadosCaptcha.success == true){
				this.captchaValido = true;
			}
		});
    }

	atualizaDataHora(){
    //console.log(this.maskdata.date);
		var data  = "";
		var hora = "";

		if (typeof(this.maskdata.date) != "undefined") {
			data = this.maskdata.date.day+"/"+this.maskdata.date.month+"/"+this.maskdata.date.year;
		}

		if (data != "") {
			if (this.maskhora != "") {
				hora = this.maskhora;
			}
      else {
				hora = "00:00:00";
			}
		}
		this.denuncia.dataHoraIncidente = data+ " "+hora;
		//console.log(data+" "+hora);
	}

}



// WEBPACK FOOTER //
// ./src/app/inicio/inicio.component.ts